import units from '@/helpers/units'
import discountTypes from '@/helpers/discountTypes'
import Vue from 'vue'

function cleanSurface(state) {
    return {
        points: [],
        algorithm: 'expanding',
        entrance: 'west',
        valid: false,
        tested: false,
        canDraw: true,
        area: 0,
        accuracy: 1,
        scale: 1,
        surface: state.materials.surfaces.length > 0 ? state.materials.surfaces[0].id : null,
        joist: state.materials.joists.length > 0 ? state.materials.joists[0].id : null,
        plank: state.materials.planks.length > 0 ? state.materials.planks[0].id : null,
        slat: state.materials.slats.length > 0 ? state.materials.slats[0].id : null, ////
        bars: [],
        edges: []
    }
}

export default {
    appendSurface(state) {
        state.configurator.surfaces.push(cleanSurface(state))
    },
    setEditData(state, data) {
        data.offer.items.forEach(item => {
            item.discountType = discountTypes[item.discount_type]
            item.unit = units.find(unit => unit.id == item.unit)
        })
        data.surfaces.forEach(surface => {
            surface.valid = true
            surface.tested = true
            surface.canDraw = false
            surface.accuracy = 1
            surface.scale = 1
            surface.bars = []
            surface.edges = []
        })
        data.customer.is_company = !!data.customer.is_company
        Object.assign(state.configurator, data)
    },
    cleanConfigurator(state) {
        state.configurator.id = null
        state.configurator.number = null
        state.configurator.surfaces = [cleanSurface(state)]
        state.configurator.customer = { isCompany: false }
        state.configurator.offer.items = []
        state.configurator.type = null
        state.configurator.partner = null
    },
    removeSurface(state, index) {
        state.configurator.surfaces.splice(index, 1)
    },
    setItems(state, payload) {
        state.items = payload
    },
    setSurface(state, payload) {
        state.configurator.points = payload
    },
    setSurfaceParam(state, payload) {
        let surface = state.configurator.surfaces[payload.index]
        surface[payload.attribute] = payload.value
    },
    appendEdge(state, payload) {
        state.configurator.surfaces[payload.surface].edges.push({
            id: payload.edge.id,
            segment: payload.edge.segment.points
        })
    },
    removeEdge(state, payload) {
        let index = state.configurator.surfaces[payload.surface].edges.indexOf(payload.edge)
        state.configurator.surfaces[payload.surface].edges.splice(index, 1)
    },
    setCustomerProperty(state, payload) {
        // state.configurator.customer[payload.param] = payload.value
        Vue.set(state.configurator.customer, payload.param, payload.value);
    },
    setPartner(state, payload) {
        // state.configurator.customer[payload.param] = payload.value
        state.configurator.partner = payload;
        // Vue.set(state.configurator.partner, id, payload);
    },
    setAvailableMaterials(state, payload) {
        state.materials.planks = payload.planks
        state.materials.surfaces = payload.surfaces
        state.materials.joists = payload.joists
        state.materials.slats = payload.slats /////
        state.materials.additionals = payload.additionals /////
        state.materials.stair = payload.stair /////
        state.materials.elevation = payload.elevation /////
        state.materials.allslats = payload.allslats /////
        state.materials.corner = payload.corner /////
        state.materials.systems = payload.systems
        state.materials.loaded = true
    },
    setAvailableManualMaterials(state, payload) {
        state.manualMaterials.planks = payload.planks
        state.manualMaterials.surfaces = payload.surfaces
        state.manualMaterials.joists = payload.joists
        state.manualMaterials.slats = payload.slats /////
        state.manualMaterials.stair = payload.stair /////
        state.manualMaterials.additionals = payload.additionals /////
    },
    setAvailableJoists(state, payload) {
        state.materials.joists = payload.joists
        state.materials.loaded = true
    },
    setAvailableSlats(state, payload) {
        state.materials.slats = payload.slats
        state.materials.loaded = true
    },
    setAvailableSurfaces(state, payload) {
        state.materials.surfaces = payload.surfaces
        state.materials.loaded = true
    },
    setArrangedData(state, data) {
        state.configurator.surfaces.forEach((surface, index) => {
            Object.assign(surface, data[index])
        })
    },
    setAlgorithm(state, algorithm) {
        state.configurator.algorithm = algorithm
    },
    setEntrance(state, entrance) {
        state.configurator.entrance = entrance
    },
    projectStatus(state, status) {
        state.configurator.projects.status = status
    },
    clearProjects(state) {
        state.configurator.projects.items = []
    },
    setProjects(state, projects) {
        state.configurator.projects.items = projects
    },
    assignProjects(state, payload) {
        payload.forEach(surface => {
            let item = state.configurator.projects.items.find(item => item.id == surface.id)
            if(item) {
                item.projects = Object.assign({}, item.projects, surface.projects)
            } else {
                state.configurator.projects.items.push(surface)
            }
        })
    },
    customerClearPrivate(state) {
        delete state.configurator.customer.firstname
        delete state.configurator.customer.lastname
    },
    customerClearCompany(state) {
        delete state.configurator.customer.company
        delete state.configurator.customer.nip
    },
    setOfferItems(state, payload) {
        state.configurator.offer.items = payload
    },
    editOfferItem(state, payload) {
        let item = state.configurator.offer.items[payload.index]
        item = Object.assign(item, payload.data)
    },
    addOfferItem(state, payload) {
        payload.data.price = parseFloat((payload.data.price / state.configurator.currency.rate).toFixed(2))
        state.configurator.offer.items.push(payload.data)
    },
    removeOfferItem(state, payload) {
        let index = state.configurator.offer.items.indexOf(payload)
        state.configurator.offer.items.splice(index, 1)
    },
    setUsers(state, payload) {
        state.users = payload
    },
    updateMyCompany(state, payload) {
        Object.assign(state.company, payload)
    },
    updateItem(state, { payload, id }) {
        let item = state.items.find(i => i.id === id)
        item = Object.assign(item, payload)
    },
    pushItem(state, payload) {
        state.items.push(payload)
    },
    removeItem(state, id) {
        let index = state.items.findIndex(i => i.id === id)
        state.items.splice(index, 1)
    },
    applayGlobalDiscount(state, payload) {
        state.configurator.offer.items.map(item => {
            let total = item.price * item.amount * (1 - payload.data / 100)
            item.discount = payload.data
            item.total = Math.round(total * 100) / 100
            item.discountType = payload.type

        });
    },
    setCurrentStep(state,payload){
        state.currentStep = payload
    },
    setCurrencies(state, payload){
        state.currencies = payload;
    },
    recalculateByCurrency(state, payload){
        state.configurator = Object.assign({},state.configurator, {currency: payload, rate: payload.rate})

        state.configurator.offer.items.map(function(item){
            let orgItem = state.items.find(org => org.id == item.item_id)
            item.price = parseFloat((orgItem.price / payload.rate).toFixed(2))
            item.total = parseFloat((item.price * item.amount).toFixed(2))
        })
    },
    setDefaultCurrency(state,payload){
        let currency = state.currencies.find(currency => currency.language == payload)
        state.configurator = Object.assign({},state.configurator,{defaultCurrency: currency})
    },
    setSystem(state, payload){
        state.system = payload;
        // state.materials.loaded = false;
    }
}
